<template>
  <ModalComponent @close="close">
    <div slot="body" class="modal">
      <div class="modal-title">PARTICIPER</div>
      <div class="modal-underline"></div>

      <div class="modal-button" @click="close">
        <i class="fas fa-times-circle"></i>
      </div>

      <ContactQuestionComponent
        :showTrainings="true"
        :trainingId="trainingId"
        class="contact-component"
        :shadow="false"
      ></ContactQuestionComponent>
    </div>
  </ModalComponent>
</template>

<script>
import ModalComponent from '../ModalComponent'
import ContactQuestionComponent from '@/components/question/ContactQuestionComponent'

export default {
  name: 'ParticipateModal',

  components: {
    ModalComponent,
    ContactQuestionComponent
  },

  props: {
    trainingId: {
      type: Number,
      default: -1
    }
  },

  mounted () {
    // Teleport to body to escape any ancestor stacking context (navbar, training cards)
    if (this.$el && this.$el.parentNode !== document.body) {
      document.body.appendChild(this.$el)
    }
  },

  beforeDestroy () {
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el)
    }
  },

  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  position: relative;
  overflow: hidden;
  width: 1124px;
  max-width: 100%;
  box-sizing: border-box;

  @include media(tablet) {
    width: 100%;
    height: auto;
    min-width: unset;
  }
}

.modal-title {
  @extend %default-title;

  text-align: left;
  padding-top: 30px;

  margin-left: 64px;

  @include media (tablet) {
    margin-left: 20px;
    padding-top: 20px;
  }
}

.modal-underline {
  @extend %default-underline;
  margin-left: 64px;
  margin-bottom: 0;

  @include media (tablet) {
    margin-left: 20px;
  }

}

.modal-button {
  position: absolute;

  top: 10px;
  right: 10px;

  color: #B98A30;

  font-size: 1.7rem;

  cursor: pointer;

  @include media (tablet) {
    top: 20px;
    right: 20px;
  }
}

.contact-component {
  height: auto;

  @include media(phone) {
    height: auto;
  }

  @include media(tablet) {
    height: auto;
  }
}
</style>
